document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".nav-tabs .tab");
  const contents = document.querySelectorAll(".nav-content .content");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      contents[index].classList.add("active");
    });
  });
});
